import React, { useState } from "react";
import Modal from "../../components/Modal";
import { RotatingLines } from "react-loader-spinner";
import { toast } from "react-toastify";
import { useAuth } from "../../context/Auth";
import Swal from "sweetalert2";

const ModifyReturnItemModal = ({ modalOpen, setModalOpen, sale_item }) => {
    const { requestWithAuth } = useAuth();
    const [quantity, setQuantity] = useState(sale_item?.quantity);
    const [approving, setApproving] = useState(false);

    const returnSale = (e) => {
        e.preventDefault();
        if(quantity <= 0){
            toast.error("Quantity must be greater than 0");
            return;
        }else if(parseInt(quantity) == parseInt(sale_item?.quantity)){
            toast.error("You didn't make any change to the quantity");
            return;
        }else if(parseInt(quantity) > parseInt(sale_item?.quantity)){
            toast.error("Quantity must not be higher than quantity sold");
            return;
        }
        Swal.fire({
          icon: "question",
          title: `Are you sure you want to return this quantity?`,
          showDenyButton: true,
          confirmButtonText: "Yes Proceed!",
        }).then(async (result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            setApproving(true);
            const body=JSON.stringify({
                return_type:"partial",
                item_id:sale_item.id,
                quantity:quantity
            })
            try {
              const data = await requestWithAuth(
                `/inventory/return-sale/${sale_item.sale_id}/`,
                "POST", body,{
                    'Content-Type':"application/json"
                }
              );
              Swal.fire({
                icon: "success",
                title: "Success!",
                text: "Sale returned Successfully",
              }).then(() => {
                window.location.reload();
              });
            } catch (error) {
              toast.error("Something unexpected happened.");
            } finally {
              setApproving(false);
            }
          } else if (result.isDenied) {
            Swal.fire("Changes are not saved", "", "info");
          }
        });
      };

  return (
    <div>
      <Modal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        title="Credit Sale Details"
      >
        <h4>Modify Item</h4>
        <form onSubmit={(e)=>returnSale(e)}>
            <div className="grid grid-cols-2 gap-4 mt-3">
                <div>
                    <label htmlFor="item">Item Name</label>
                    <input type="text" className="border border-[#ddd] rounded-[3px] h-[36px] w-full text-[#333] text-[13px] px-[12px] py-[7px]" name="item" id="item" placeholder="Item Name" value={sale_item?.drug} disabled />
                </div>
                <div>
                    <label htmlFor="quantity">Quantity</label>
                    <input type="number" className="border border-[#ddd] rounded-[3px] h-[36px] w-full text-[#333] text-[13px] px-[12px] py-[7px]" name="quantity" id="quantity" placeholder="Quantity" value={quantity} onChange={(e)=>setQuantity(e.target.value)} />
                </div>
            </div>
            <div className="flex justify-end">
                
                <button  className="bg-[#2196F3] px-[12px] py-[7px] text-[13px] rounded-[3px] mt-5 text-white">
                  Submit Form
                </button>
              
            </div>
        </form>
      </Modal>
    </div>
  );
};

export default ModifyReturnItemModal;
